module.exports = __webpack_public_path__ + "img/Schulung.fc52c9d9.gif";